export const GET_SETTINGS = 'INSTITUTIONS/get_settings';
export const GET_SINGLE_SETTING = 'INSTITUTIONS/get_single_setting';
export const UPDATE_SETTING = 'INSTITUTIONS/update_setting';
export const CREATE_SETTING = 'INSTITUTIONS/create_setting';
export const REMOVE_SETTING = 'INSTITUTIONS/remove_setting';

export const GET_ROLE_LIST = 'ROLE/get_role_list';

export const FORM_DATA = {
  name: '',
};
